export default __webpack_public_path__ + "static/media/tim.ef49bfa9.jpg";